import React from 'react';

const PlayIcon = () => (
    <svg viewBox="0 0 12 15" aria-hidden="true">
        <path d="M11.5192362,8.44711223 L1.50387103,14.2894086 C1.02681911,14.5676889 0.414501382,14.4065526 0.136221099,13.9295007 C0.0470083978,13.7765646 -6.63005568e-16,13.6026843 -9.99200722e-16,13.4256297 L6.66133815e-16,1.741037 C5.9849844e-16,1.18875225 0.44771525,0.741036999 1,0.741036999 C1.17705464,0.741036999 1.35093497,0.788045397 1.50387103,0.877258098 L11.5192362,6.71955443 C11.9962881,6.99783472 12.1574243,7.61015244 11.879144,8.08720436 C11.7922253,8.23620799 11.6682398,8.36019345 11.5192362,8.44711223 Z" />
    </svg>
);

export default PlayIcon;
